import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from '@services/base.service';
import { FolderResourceTemplate } from './folder-structure.types';

const ENDPOINT = 'folder_resource_templates';

@Injectable({ providedIn: 'root' })
export class FolderStructurePocService extends BaseService {
  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient);
  }

  loadAll(q?: string): Observable<FolderResourceTemplate.Item[]> {
    let params = new HttpParams();
    if (q) {
      params = params.set('q', q);
    }

    return this.httpClient
      .get<FolderResourceTemplate.GetAllResponse>(ENDPOINT, { params })
      .pipe(map(({ folder_resource_templates }) => folder_resource_templates));
  }

  getById(id: string): Observable<FolderResourceTemplate.Item> {
    return this.httpClient
      .get<FolderResourceTemplate.DefaultResponse>(`${ENDPOINT}/${id}`)
      .pipe(map(({ folder_resource_template }) => folder_resource_template));
  }

  create(params: {
    name: string;
    related_to_type: string;
    project_template_id: number | null;
    definition: FolderResourceTemplate.ItemDefinition[];
  }): Observable<FolderResourceTemplate.Item> {
    return this.httpClient
      .post<FolderResourceTemplate.DefaultResponse>(ENDPOINT, { folder_resource_template: params })
      .pipe(map(({ folder_resource_template }) => folder_resource_template));
  }

  update(
    id: string,
    params: { name: string; project_template_id: number | null; definition: FolderResourceTemplate.ItemDefinition[] },
  ): Observable<FolderResourceTemplate.Item> {
    return this.httpClient
      .put<FolderResourceTemplate.DefaultResponse>(`${ENDPOINT}/${id}`, { folder_resource_template: params })
      .pipe(map(({ folder_resource_template }) => folder_resource_template));
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${ENDPOINT}/${id}`);
  }
}
